var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"template-container",class:{
    'template-container--impersonate': _vm.isImpersonate,
    'template-container--nomargin': !_vm.hasMargin
  }},[_c('div',{staticClass:"view-container"},[_c('div',{staticClass:"template-main",class:{ 'template-main--scroll': _vm.singleScroll }},[_vm._t("main")],2),_c('div',{class:_vm.computedPaddingClass},[_vm._t("content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }